/* eslint-disable react/react-in-jsx-scope */
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { Skeleton } from "@/components/ui/skeleton";
import { Indicator } from "@/types/dashboard";
import ChartItemGlobal from "../project/components/ChartItemGlobal";

const ChartsDashboard = ({ programReport, reportData, reportLoading }) => {
  // const programReport = useFetchDataV2(
  //   `${import.meta.env.VITE_API_ENDPOINT}/report/programs?context=dashboard`,
  //   `report`,
  //   1000 * 60 * 60
  // );

  return (
    <div>
      <div className="grid grid-cols-2 gap-4">
        {(!programReport?.data || reportLoading || !reportData) && (
          <div className="w-full grid grid-cols-2 gap-4">
            <ChartSkeleton />
            <ChartSkeleton />
          </div>
        )}
        {!programReport?.data || reportLoading || !reportData ? (
          <LoadingSpinner />
        ) : (
          (reportData?.indicators ?? [])
            .filter((i) => i?.id != 2)
            .map((indicator: Indicator, k: number) => (
              <ChartItemGlobal
                key={k}
                dataReporting={reportData?.projectIndicators}
                minDate={
                  reportData?.minDate
                    ? parseInt(reportData.minDate)
                    : new Date().getFullYear()
                }
                maxDate={
                  reportData?.maxDate
                    ? parseInt(reportData.maxDate)
                    : 2050
                }
                indicator={indicator}
                width="w-full"
                maxTco2Year={reportData?.maxTco2Year}
                context="dashboard"
              />
            ))
        )}
      </div>
    </div>
  );
};

export default ChartsDashboard;

export const ChartSkeleton = () => {
  return (
    <div className="mb-4 basis-1/2 h-[400px] bg-[#F7F9FB] rounded-[20px]">
      <div className="flex flex-row items-center justify-start mx-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#bdbebf"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-chevron-down-icon lucide-chevron-down"
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
        <Skeleton className="rounded-full w-[150px] h-5 m-5 bg-[#ecedee]" />
      </div>
      <div className="grid grid-cols-2">
        <div className="flex flex-col justify-between">
          <Skeleton className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]" />
          <Skeleton className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]" />
          <Skeleton className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]" />
        </div>
        <div>
          <div className="flex flex-row gap-16 items-end justify-end mx-5">
            <Skeleton className="rounded-full w-[25px] h-[100px] bg-[#ecedee]" />
            <Skeleton className="rounded-full w-[25px] h-[200px] bg-[#ecedee]" />
            <Skeleton className="rounded-full w-[25px] h-[275px] bg-[#ecedee]" />
            <Skeleton className="rounded-full w-[25px] h-[250px] bg-[#ecedee]" />
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-between">
        {Array.from({ length: 7 }).map((_, k) => (
          <Skeleton
            className="rounded-full w-[50px] h-3 m-5 bg-[#ecedee]"
            key={k}
          />
        ))}
      </div>
    </div>
  );
};
